<template>
  <div class="d-flex" :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
    <div :id="uuid+'_legend'">
      <div v-for="(element, index) in systems" :key="element" class="mb-1">
        <v-avatar :color="palette[index]" size="30">
          <span style="font-size: 10px; z-index: 2; font-weight: bold;" :style="`color: ${ Colorize(palette[index]) }`">{{ element.split(' - ')[0] }}</span>
        </v-avatar>
        <span style="margin-left: -3px; padding-left: 10px; z-index: 1" :style="`border-bottom: 1px solid ${palette[index]}`">{{ element.split(' - ')[1] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import {Colorize, palette} from "@/libs/colorizer";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "07fcd944-7ce5-11eb-811b-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      objecto: null,
      datasets: [],
      systems: [],
      count: [],
      labels: [],
      datus: []
    }
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: ['Коэффициент'],
            datasets: this.datasets,
          },
          options: {
            indexAxis: 'y',
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            },
            plugins: {
              autocolors: {
                mode: 'data'
              },
              legend: {
                display: false,
                position: 'right'
              },
              datalabels: {
                anchor: 'center',
                clamp: true,
                align: 'center',
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor[0])
                },
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.systems = []
      this.count = []
      this.labels = []
      this.datus = []
      this.datasets = []

      for (let i = 0; i < this.chart.report_data.length; i++) {
        this.systems.push(this.chart.report_data[i]["ПодсистемаПРЕДСТАВЛЕНИЕ"])
        this.count.push(this.chart.report_data[i]["Колво"])
      }
      for (let i = 0; i < this.systems.length; i++) {
        this.datasets.push(
            {
              label: this.systems[i],
              data: [this.chart.report_data.find(el => el["ПодсистемаПРЕДСТАВЛЕНИЕ"] === this.systems[i])["Колво"]],
              maxBarThickness: 200,
            }
        )
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>